import React, { useEffect } from 'react';

import {
  WidgetContainer,
  WidgetTitle,
  StyledTable,
  TableHeaderCell,
  TableRowCell,
} from './styles';
import {
  widgetRoles,
  sampleFrequencyRoles,
  deliveryCategoryRoles,
} from './types';
import { useI18n } from '../../../../hooks/useI18n';
import { TranslationKeys } from '../../../../i18n/locales/defaultResources';
import SecurityTrim from '../../../../services/auth/SecurityTrim';
import { useSampleFrequencyStore } from '../../../../stores/sampleFrequencyStore';
import { useContextStore } from '../../../../stores/contextStore';

const SampleFrequencyWidget: React.FC = () => {
  const { t } = useI18n();
  const { activeBpNumber, isAccessOnBehalf } = useContextStore();
  const { sampleFrequencies, getSampleFrequencies, clearData } =
    useSampleFrequencyStore();

  useEffect(() => {
    getSampleFrequencies();
    return () => {
      clearData();
    };
  }, [getSampleFrequencies, clearData, activeBpNumber, isAccessOnBehalf]);

  return (
    <SecurityTrim requiredBusinessPartnerRoles={widgetRoles}>
      <WidgetContainer>
        <WidgetTitle>
          {t(TranslationKeys.samplefrequency_widget_title)}
        </WidgetTitle>
        <StyledTable>
          <thead>
            <tr>
              <TableHeaderCell></TableHeaderCell>
              <SecurityTrim requiredBusinessPartnerRoles={sampleFrequencyRoles}>
                <TableHeaderCell>
                  {t(TranslationKeys.samplefrequency_table_header_cell_sample)}
                </TableHeaderCell>
              </SecurityTrim>
              <SecurityTrim
                requiredBusinessPartnerRoles={deliveryCategoryRoles}
              >
                <TableHeaderCell>
                  {t(
                    TranslationKeys.samplefrequency_table_header_cell_devlivery_category
                  )}
                </TableHeaderCell>
              </SecurityTrim>
            </tr>
          </thead>
          <tbody>
            {sampleFrequencies.map((row, index) => {
              const hasSampling = row.samplingPercentage !== null;
              const hasDelivery = row.deliveryCategory !== null;

              return (
                <tr key={index}>
                  <TableRowCell>{row.year}</TableRowCell>
                  <SecurityTrim
                    requiredBusinessPartnerRoles={sampleFrequencyRoles}
                  >
                    <TableRowCell>
                      {hasSampling ? `${row.samplingPercentage}` : ''}
                    </TableRowCell>
                  </SecurityTrim>
                  <SecurityTrim
                    requiredBusinessPartnerRoles={deliveryCategoryRoles}
                  >
                    <TableRowCell>
                      {hasDelivery ? row.deliveryCategory : ''}
                    </TableRowCell>
                  </SecurityTrim>
                </tr>
              );
            })}
          </tbody>
        </StyledTable>
      </WidgetContainer>
    </SecurityTrim>
  );
};

export default SampleFrequencyWidget;
